import { Space } from 'component/Space'
import { ShopLogo } from 'feature/page/ShopLogo/ShopLogo'
import { webview } from 'feature/webview/webview'
import { try_on } from 'feature/widget/TryOnStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ComboCartAction } from 'page/catalog/ComboCart/ComboCartAction'
import { HeaderAction } from 'page/catalog/HeaderAction/HeaderAction'
import { OutfitsPreview } from 'page/catalog/OutfitsPreview/OutfitsPreview'
import { ShareButton } from 'page/catalog/ShareButton/ShareButton'
import { ShopButton } from 'page/catalog/ShopButton/ShopButton'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { WebviewCloseButton } from 'page/catalog/WebviewCloseButton/WebviewCloseButton'
import css from './Header.module.scss'

export const Header = observer(() => {
  const demo = useDemo()
  const { logo, logoUrl, shopUrl, shopButtonVisible, shareCatalogButton, combination } =
    demo.product
  const shop = shopButtonVisible && !!shopUrl

  const onOutfits = useLatestCallback(async () => {
    await try_on.open()
  })

  const onOpenComboCart = useLatestCallback(() => {
    comboCartStore.open = true
  })

  return (
    <Space className={css.header} gap={12} opposite>
      <Space>
        <ShopLogo logo={logo} link={logoUrl} compact />
      </Space>
      <Space className={css.actions}>
        {shop && <ShopButton />}
        {shareCatalogButton && <ShareButton />}
        <HeaderAction
          bare
          icon={<OutfitsPreview />}
          label={i18n('demo.MyOutfits')}
          action={onOutfits}
        />
        {combination && <ComboCartAction onOpen={onOpenComboCart} />}
        {webview.detected && <WebviewCloseButton />}
      </Space>
    </Space>
  )
})
